export * from './avatar';
export * from './languages.json';
export * from './routes';
export * from './tabList';
export * from './transportationType';
export * from './tour';
import axios from 'axios';

export const numberWithCommas = (number) => {
  if (number || typeof number === 'number')
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  else return '';
};
export const Conditional = ({ checkRender, children }) => {
  return !!checkRender && children;
};

export const getUserInfoByIP = () => {
  return new Promise(function (resolve, reject) {
    //https://api.freegeoip.app/json/?apikey=475e6410-46ca-11ec-9bdd-79dd5b5bc51f
    axios
      .get('https://api.db-ip.com/v2/free/self')
      // .get('https://ipapi.co/json/') // change api https://api.freegeoip.app/json/?apikey=475e6410-46ca-11ec-9bdd-79dd5b5bc51f instedof http://ip-api.com/json
      .then((response) => {
        return response.json();
      })
      .then((userIpInfo) => {
        resolve(userIpInfo);
      })
      .catch((err) => {
        resolve({
          status: 'success',
          ipAddress: '79.127.7.75',
          continentCode: 'AS',
          continentName: 'Asia',
          countryCode: 'IR',
          countryName: 'Iran',
          stateProv: 'Tehran',
          city: 'Tehran',
        });
      });
  });
};
export const isRTL = ({ string }) => {
  var ltrChars =
      'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF' +
      '\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF',
    rtlChars = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC',
    rtlDirCheck = new RegExp('^[^' + ltrChars + ']*[' + rtlChars + ']');

  return rtlDirCheck.test(s);
};

export const range = (min, max) =>
  [...Array(max - min + 1).keys()].map((i) => i + min);
